import { IPropertyBookingLink } from 'src/pages/Calendar/CalcomIntegration/types';

export const groupByProperty = (
  links: IPropertyBookingLink[]
): Record<string, IPropertyBookingLink[]> => {
  const grouped: Record<string, IPropertyBookingLink[]> = {};

  links.forEach((link: IPropertyBookingLink) => {
    const bucket: IPropertyBookingLink[] = grouped[link.propertyId] ?? [];
    bucket.push(link);

    grouped[link.propertyId] = bucket;
  });

  return grouped;
};